<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const isFullBleed = computed(() => Boolean(route.meta?.fullBleed));
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 bg-n-surface-1"
    :class="
      isFullBleed ? 'overflow-hidden p-0' : 'pb-8 pt-4 px-6 overflow-auto'
    "
  >
    <div
      class="flex items-start w-full mx-auto"
      :class="isFullBleed ? 'h-full max-w-none w-full' : 'max-w-5xl'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive && !isFullBleed">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
